<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="isShowLoginDialog" :append-to-body="true"
    custom-class="loginDialog" width="480px" :center="true" :before-close="handleClose">
    <div class="loginMainRight">
      <div class="loginBox">
        <!-- 图片 -->
        <div class="top-pic">
          <router-link to="/"> <img src="../../assets/homePage/sponlax-logo.svg" alt="" /></router-link>
        </div>
        <div class="inputBox">
          <el-form :model="loginData" :rules="loginRules" ref="loginForm" class="demo-ruleForm">
            <div class="loginmobie">{{ $fanyi("电子邮件/手机号码") }}</div>
            <el-form-item prop="login_name">
              <el-input v-model="loginData.login_name" :placeholder="$fanyi('请输入邮箱/手机号')"></el-input>
            </el-form-item>
            <div class="loginpassword">{{ $fanyi("密码") }}</div>
            <el-form-item prop="password">
              <el-input v-model="loginData.password" :type="passwordtype" :placeholder="$fanyi('请输入密码')"
                @input="passwordChannelInputLimit">
                <template slot="suffix">
                  <div class="eyes">
                    <img v-if="passwordtype == 'password'" @click="passwordtype = 'text'"
                      src="../../assets/newassets/login/password1.svg" alt="">
                    <img v-else @click="passwordtype = 'password'" src="../../assets/newassets/login/password2.svg"
                      alt="">
                  </div>
                </template>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="footer">
          <div class="forgetPassword">
            <div class="fl">
              <el-checkbox v-model="Save_the_password"></el-checkbox>
              <span>{{ $fanyi("保持登录状态") }}</span>
            </div>
            <div class="fr">
              <span class="wangJiMiMa" @click="$fun.toPage('/forgetThePassword')">
                {{ $fanyi("忘记密码?") }}
              </span>
            </div>
          </div>
          <div class="btnBox">
            <el-button @click="login">{{ $fanyi("登录") }}</el-button>

          </div>
          <div class="register">
            <a href="javascript:;" @click="$fun.toPage('/register')">{{
              $fanyi("新会员注册")
            }}</a>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>

export default {
  data() {
    return {
      isShowLoginDialog: false,
      Save_the_password: false,
      loginData: {
        login_name: localStorage.getItem("russiausername")
          ? localStorage.getItem("russiausername")
          : "",
        password: localStorage.getItem("russiapassword")
          ? localStorage.getItem("russiapassword")
          : "",
      },
      path: '',
      loginRules: {
        login_name: [
          {
            required: true,
            message: this.$fanyi("请输入邮箱/手机号"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$fanyi("请输入密码"),
            trigger: "blur",
          },
        ],
      },
      passwordtype: 'password',
    };
  },
  created() {
    let that = this;
    document.onkeypress = function (e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13) {
        that.login(); // 登录方法名
        return false;
      }
    };
    localStorage.getItem("russiakeep") == 1
      ? (this.Save_the_password = true)
      : (this.Save_the_password = false);
  },

  methods: {
    login() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          // 记住密码
          if (this.Save_the_password == true) {
            localStorage.setItem("russiausername", this.loginData.login_name);
            localStorage.setItem("russiapassword", this.loginData.password);
            localStorage.setItem("russiakeep", 1);
          } else {
            localStorage.removeItem("russiausername");
            localStorage.removeItem("russiapassword");
            localStorage.removeItem("russiakeep");
          }
          this.$api
            .logins({
              login_account: this.loginData.login_name,
              password: this.loginData.password,
            })
            .then((res) => {
              if (!res.success)
                return this.$message.error(
                  this.$fanyi("邮箱、手机号或密码输入错误")
                );
              localStorage.setItem("russia_user_token", res.data.user_token);
              this.$api.EuropegetUserInfo().then((res) => {
                this.$store.commit("userData", res.data);
                if (this.path != '') {
                  this.$router.push(this.path)
                  this.path = ''

                }
              });
              // 获取侧边栏数据
              this.isShowLoginDialog = false
              this.$store.dispatch("goodsToCartNum");
            });
        }
      });
    },

    open(url) {
      if (url) {
        this.path = url
      }
      this.isShowLoginDialog = true
    },
    passwordChannelInputLimit(e) {

      this.loginData.password = e.replace(/[^A-Za-z0-9~!@#$%^+-.]/g, "");
    },
    handleClose() {

      this.isShowLoginDialog = false
    },
  },
};
</script>
<style></style>
<style lang="scss" scoped>
/deep/.loginDialog {
  position: relative;
  width: 480px;

  background: #FFFFFF;
  border-radius: 20px;
  padding: 40px;

  padding-bottom: 60px;

  .el-dialog__header {
    height: 26px;

    .el-dialog__headerbtn {
      right: 32px;
      top: 30px;

      .el-dialog__close {
        font-weight: 600;
        font-size: 18px;
        color: #000;
      }
    }
  }

  .el-dialog__footer {
    display: none;
  }

  .el-dialog__body {
    padding: 0px;
  }

  .loginMainRight {
    display: flex;
    justify-content: center;

    align-items: center;
    width: 100%;



    .loginBox {

      width: 100%;

      .top-pic {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        // height: 194px;
        margin-bottom: 60px;

        img {
          width: 198px;
          height: 37px;
        }
      }

      .loginmobie,
      .loginpassword {
        margin-bottom: 10px;
        font-size: 16px;
        font-family: Roboto;
        font-weight: 400;
        color: #222222;
      }

      // 登录
      .inputBox {


        .el-input {
          width: 400px;
          height: 48px;
        }

        .el-input__suffix {

          right: 20px;
          width: 20px;
          display: flex;

          align-items: center;
          justify-content: center;

          .el-icon-view {
            font-size: 18px;
          }

          .eyes {
            display: flex;
            align-items: center;
            justify-content: center;

            :hover {
              cursor: pointer;
            }
          }
        }

        .el-input__inner {

          width: 400px;
          height: 48px;
          background: #FFFFFF;
          border-radius: 12px;
          border: 1px solid #DFDFDF;
          font-size: 14px;
        }
      }

      .btnBox {
        margin-top: 60px;

        .el-button {
          width: 400px;
          height: 56px;
          background: #D12A1D;
          border-radius: 12px;
          font-size: 18px;

          color: white;
          border: none;
        }
      }

      .footer {
        width: 100%;
      }

      .forgetPassword {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 24px;

        .fl {
          display: flex;
          align-items: center;



          .el-checkbox__input {
            height: 20px;
            margin-right: 10px;

            .el-checkbox__inner {
              width: 20px;
              height: 20px;
              border-radius: 6px;
              border: 1px solid #D4D4D4;

              &::after {
                position: absolute;
                top: 45%;
                width: 4px;
                height: 9px;
                left: 50%;
                transform: translate(-50%, -50%) rotate(45deg);
              }
            }
          }

          /deep/ .el-checkbox__input.is-checked {
            .el-checkbox__inner {
              background-color: #D12A1D;
              border-color: #D12A1D;
            }
          }
        }

        .fr {
          .wangJiMiMa {
            text-decoration: underline;
            cursor: pointer;
            color: #D12A1D;
          }
        }



      }

      .register {
        margin-top: 22px;
        text-align: center;

        a {
          font-size: 14px;
          color: #D12A1D;
          line-height: 20px;
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
